const deviceOnline = state => state.deviceIsOnline;

export default deviceOnline;
